import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromNotifications from './state/notifications.reducer';
import { NotificationsEffects } from './state/notifications.effects';

@NgModule({
    imports: [
        StoreModule.forFeature(
            fromNotifications.NOTIFICATIONS_FEATURE_KEY,
            fromNotifications.reducer
        ),
        EffectsModule.forFeature([NotificationsEffects]),
    ],
})
export class PortalsNotificationsStateModule {}
